import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { Metamodel } from 'app/model/base/model';
import { GreenplumTableDataset } from 'app/model/dataset/greenplum.dataset';
import { GreenplumLinkedService } from 'app/model/linkedservice/greenplum.linkedservice';
import { extendedColumnTypes } from 'app/shared/utils/column-type.util';
import { format } from 'app/shared/utils/string.util';

export const greenplumTableMetadata: IDatasetTypeMetadata = {
    type: Metamodel.modelFor(GreenplumTableDataset).name,
    displayName: stringResources.Greenplum_DisplayText,
    supportLinkedServiceTypes: [Metamodel.modelFor(GreenplumLinkedService).name],
    isSource: true,
    isSink: false,
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-greenplum'
    },
    showWarningMessage: '{ linkedService && linkedService.version !== "v2" }',
    warningMessage: format(
        stringResources.Dataset_Legacy_IsNotSupportedWarning_alt3,
        stringResources.VersionLabel.toLocaleLowerCase()
    ),
    warningMessageHyperlink: 'https://learn.microsoft.com/azure/data-factory/connector-greenplum',
    isFirstClass: true,
    supportCreatedAsV2: true,
    splitTablePath: true,
    notSupportPhysicalType: true,
    v1SupportSchema: true,
    supportDataTypes: extendedColumnTypes,
    category: ['Database']
};
